import type { PrescriptionMedicationsTableRow } from '../PrescriptionMedicationsTable.types';
import { DISABLE_CANCEL, ENABLE_CANCEL, HIDE_CANCEL } from '../PrescriptionMedicationsTable.types';

export const isProductCancellable = ({
  product,
  isPrescriptionsEditable,
  hasUserPermissions,
  cancelInProgress
}: {
  product: PrescriptionMedicationsTableRow;
  isPrescriptionsEditable: boolean;
  hasUserPermissions: boolean;
  cancelInProgress: boolean;
}) => {
  const statusNotActive = product.status !== 'Active';
  const isPaperScript = product.prescriptionProductCode ? product.prescriptionProductCode.startsWith('ALPR') : false;
  const isRefillScript = product.isRefillScript;

  if (!isPrescriptionsEditable || isRefillScript) {
    return HIDE_CANCEL;
  }

  if (statusNotActive || isPaperScript || cancelInProgress || !hasUserPermissions) {
    return DISABLE_CANCEL;
  }

  return ENABLE_CANCEL;
};
